<template>
  <div class="Prouct" ref="product">
    <div class="firstImg">
      <img src="@/img/product_img2.png">
      <div class="mengban"></div>
    </div>
    <!-- 特色产品模块 -->
    <div class="tese">
      <div class="tese_boxs" >
        <div class="tese_titleBox">
          <span class="tese_title1 tese_title">热绝缘</span><span class="tese_title2 tese_title">组件及产品</span>
          <span class="tese_enTitle">THERMAL COMPONENTS</span>
          <p>性能卓越，可靠耐用，适用广泛，易于拓展，满足用户多种需求，具备卓越的长期稳定性</p>
          <a href="#products_boxs"><Icon type="jiantou"></Icon> 所有产品</a>
        </div>
        <div class="tese_mainBox">
          <div class="tese_bottom">
            <div class="tese_indexs">
              <div class="tese_index" @click="teseChange(index)" :class="[{'tese_active':isActive(index)}]" v-for="(tese,index) in teses" :key="index">
                <h1>{{ tese.name }}</h1>
                <p>{{ tese.englishName }}</p>
                <div class="tese_jiantou">
                  <Icon type="jiantou"></Icon>
                </div>
              </div>
              
            </div>
            <div class="tese_img" @click="handleImageLoad">
                <img :src="teses[tese_namber-1].url">
                <!-- <el-image :src="teses[tese_namber-1].url"></el-image> -->
                <div class="tese_whiteBox ">
                  <h1>{{ teses[tese_namber-1].model }}</h1>
                  <h1>{{ teses[tese_namber-1].name }}</h1>
                  <p>{{ teses[tese_namber-1].blurb }}</p>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 汽车主要产品 -->
    <div id="products_boxs">
      <div class="products_titles">
        <div class="products_title" @click="products_titleChange(index)" :class="{'products_act':index===product_number}" v-for="(title, index) in product_type" :key="index">
          <Icon :type="title.type"></Icon><span>{{ title.name }}</span>
        </div>
      </div>
      <div class="products_imgs" ref="products">
        <div class="img_box"  v-for="(img, index) in imgs[product_number]" :key="index">
              <el-image 
              @click="picture_click(img)"
              :src="img.url" 
              @load="handleImageLoad" 
              class="product-image">
              </el-image>
              <!-- 测试是不是el-image的问题 -->
              <!-- <img :src="img.url" @load="test"> -->
              <p>{{ img.name }}</p>
        </div>
      </div>
      <div ref="products_more_text" class="products_more" v-show="more" @click="more_change()">
        <i class="el-icon-arrow-down"></i>
        <span >点击查看更多</span>
      </div>
    </div>
    <!-- 图片放大 -->
    <div class="picture_box" v-show="picture_nambar">
      <div class="main_box">
        <div class="close">
          <span class="close_main" @click="picture_state_change()">
            <Icon type="close"></Icon>
          </span>
        </div>
        <div class="pic_box">
          <!-- <img :src="pic" alt="" v-for="(pic,index) in picture" :key="index"> -->
          <div class="block">
            <el-carousel height="70vh">
              <el-carousel-item v-for="(pic,item) in picture" :key="item">
                <img :src="pic" alt="">
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
      </div>
    </div>
    <!-- 公司办公环境 -->
    
    <!-- 公司设备 -->
  </div>
</template>

<script>
import Icon from '@/components/Icon';
// import {ElImage,ElButton } from 'element-ui';
export default {
  components:{
    Icon,
    // ElImage,
    // ElButton
  },
  data() {
    return {
      product_number:0,
      product_type:
      [
        {name:'传统车配件',type:"qiche"},
        {name:'新能源产品',type:"xingnengyuan"},
        {name:'其他产品',type:"qita"},
      ],
      imgs:[
      [
        //传统车
        {class:0,url:require("@/img/products/DSC_0001.jpg"),name:"排气催化器端锥ECEC-001"},
        {class:0,url:require("@/img/products/DSC_0002.jpg"),name:"汽车排气消声包端盖CENR-001"},
        {class:0,url:require("@/img/products/DSC_0004.jpg"),name:"汽车排气消声包端盖CENR-002"},
        {class:0,url:require("@/img/products/DSC_0006.jpg"),name:"汽车排气消声包端盖CENR-004"},
        {class:0,url:require("@/img/products/DSC_0007.jpg"),name:"汽车排气消声包端盖CENR-005"},
        {class:0,url:require("@/img/products/DSC_0008.jpg"),name:"汽车排气消声包端盖CENR-006"},
        {class:0,url:require("@/img/products/DSC_0009.jpg"),name:"汽车排气消声包端盖CENR-007"},
        {class:0,url:require("@/img/products/DSC_0010.jpg"),name:"汽车排气消声包内隔板IPOA-001"},
        {class:0,url:require("@/img/products/DSC_0011.jpg"),name:"汽车排气消声包内隔板IPOA-002"},
        {class:0,url:require("@/img/products/DSC_0012.jpg"),name:"汽车排气消声包内隔板IPOA-003"},
        {class:0,url:require("@/img/products/DSC_0013.jpg"),name:"汽车排气消声包内隔板IPOA-004"},
        {class:0,url:require("@/img/products/DSC_0014.jpg"),name:"汽车排气消声包内隔板IPOA-005"},
        {class:0,url:require("@/img/products/DSC_0015.jpg"),name:"汽车排气消声包内隔板IPOA-006"},
        {class:0,url:require("@/img/products/DSC_0016.jpg"),name:"汽车排气消声包内隔板IPOA-007"},
        {class:0,url:require("@/img/products/DSC_0021.jpg"),name:"汽车排气管隔热罩CEPI-001"},
        {class:0,url:require("@/img/products/DSC_0023.jpg"),name:"汽车排气管隔热罩CEPI-003"},
        {class:0,url:require("@/img/products/DSC_0025.jpg"),name:"汽车排气管隔热罩CEPI-005"},
        {class:0,url:require("@/img/products/DSC_0026.jpg"),name:"汽车排气管隔热罩CEPI-006"},
        {class:0,url:require("@/img/products/DSC_0027.jpg"),name:"汽车排气管隔热罩CEPI-007"},
        {class:0,url:require("@/img/products/DSC_0028.jpg"),name:"汽车排气管隔热罩CEPI-008"},
        {class:0,url:require("@/img/products/DSC_0029.jpg"),name:"汽车底盘隔热罩CEPI-009"},
        {class:0,url:require("@/img/products/DSC_0030.jpg"),name:"汽车排气管隔热罩CEPI-010"},
        {class:0,url:require("@/img/products/DSC_0033.jpg"),name:"汽车排气管隔热罩CEPI-013"},
        {class:0,url:require("@/img/products/DSC_0034.jpg"),name:"汽车排气管隔热罩CEPI-014"},
        {class:0,url:require("@/img/products/DSC_0035.jpg"),name:"汽车排气端锥CEC-012"},
        {class:0,url:require("@/img/products/DSC_0037.jpg"),name:"汽车排气球形连接法兰AESC-057"},
        {class:0,url:require("@/img/products/DSC_0038.jpg"),name:"汽车扶手箱铰链CABH-024"},
        {class:0,url:require("@/img/products/DSC_0039.jpg"),name:"汽车扶手箱铰链CABH-025"},
        {class:0,url:require("@/img/products/DSC_0041.jpg"),name:"汽车车门铰链CDH-007"},
        {class:1,url:require("@/img/products/DSC_0042.jpg"),urls:[require("@/img/products/DSC_0042.jpg"),require("@/img/products/DSC_0045.jpg"),require("@/img/products/DSC_0046.jpg"),require("@/img/products/DSC_0047.jpg")], name:"汽车排气端锥CEC-001"},//组合成一个1
        {class:0,url:require("@/img/products/DSC_0044.jpg"),name:"汽车排气端锥CEC-003"},
        {class:0,url:require("@/img/products/DSC_0048.jpg"),name:"汽车排气端锥CEC-007"},
        {class:2,url:require("@/img/products/DSC_0049.jpg"),urls:[require("@/img/products/DSC_0049.jpg"),require("@/img/products/DSC_0050.jpg"),require("@/img/products/DSC_0054.jpg"),require("@/img/products/DSC_0055.jpg")], name:"汽车排气端锥CEC-008"},//组合成一个2
        {class:0,url:require("@/img/products/DSC_0051.jpg"),name:"汽车排气端锥CEC-010"},
        {class:0,url:require("@/img/products/DSC_0052.jpg"),name:"汽车排气端锥CEC-011"},
        {class:0,url:require("@/img/products/DSC_0053.jpg"),name:"汽车排气端锥CEC-012"},
        {class:2,url:require("@/img/products/DSC_0056.jpg"),name:"汽车排气端锥CEC-015"},
        {class:0,url:require("@/img/products/DSC_0057.jpg"),name:"汽车排气管连接三通半壳CEPC-087"},
        {class:0,url:require("@/img/products/DSC_0058.jpg"),name:"汽车排气尾饰组件AETT-057"},
        {class:0,url:require("@/img/products/DSC_0059.jpg"),name:"汽车排气端锥半壳组件"},
        {class:0,url:require("@/img/products/DSC_0060.jpg"),name:"汽车排气端锥"},
        {class:3,url:require("@/img/products/DSC_0061.jpg"),urls:[require("@/img/products/DSC_0061.jpg"),require("@/img/products/DSC_0062.jpg")],name:"汽车排气端锥半壳组件"},//组合成一个3
        {class:4,url:require("@/img/products/DSC_0063.jpg"),urls:[require("@/img/products/DSC_0063.jpg"),require("@/img/products/DSC_0064.jpg")],name:"汽车排气端锥半壳组件"},//组合成一个4
        {class:5,url:require("@/img/products/DSC_0065.jpg"),urls:[require("@/img/products/DSC_0065.jpg"),require("@/img/products/DSC_0066.jpg")],name:"汽车排气管隔热罩"},//组合成一个5
        {class:6,url:require("@/img/products/DSC_0090.jpg"),urls:[require("@/img/products/DSC_0090.jpg"),require("@/img/products/DSC_0091.jpg"),require("@/img/products/DSC_0092.jpg"),require("@/img/products/DSC_0093.jpg")],name:"汽车排气消声包组件"},//组合成一个6
        {class:7,url:require("@/img/products/DSC_0094.jpg"),urls:[require("@/img/products/DSC_0094.jpg"),require("@/img/products/DSC_0095.jpg"),require("@/img/products/DSC_0096.jpg")],name:"汽车三元催化器端锥"},//组合成一个7
        {class:8,url:require("@/img/products/DSC_0097.jpg"),urls:[require("@/img/products/DSC_0097.jpg"),require("@/img/products/DSC_0098.jpg"),require("@/img/products/DSC_0099.jpg"),require("@/img/products/DSC_0100.jpg")],name:"商用车催化器进气端盖"},//组合成一个8
        {class:9,url:require("@/img/products/DSC_0101.jpg"),urls:[require("@/img/products/DSC_0101.jpg"),require("@/img/products/DSC_0102.jpg"),require("@/img/products/DSC_0103.jpg"),require("@/img/products/DSC_0104.jpg")],name:"汽车消声包内组件"},//组合成一个9
        {class:10,url:require("@/img/products/DSC_0106.jpg"),urls:[require("@/img/products/DSC_0106.jpg"),require("@/img/products/DSC_0107.jpg"),require("@/img/products/DSC_0108.jpg"),require("@/img/products/DSC_0109.jpg")],name:"汽车排气消声包组件"},//组合成一个10
      ],
      [
        //新能源
        {url:require("@/img/products/DSC_0067.jpg"),urls:[require("@/img/products/DSC_0067.jpg")],name:"新能源浸塑连接铜排"}, 
        {url:require("@/img/products/DSC_0068.jpg"),urls:[require("@/img/products/DSC_0068.jpg")],name:"新能源浸塑连接铜排"},
        {url:require("@/img/products/DSC_0069.jpg"),urls:[require("@/img/products/DSC_0069.jpg")],name:"新能源连接铜排"},
        {url:require("@/img/products/DSC_0070.jpg"),urls:[require("@/img/products/DSC_0070.jpg")],name:"新能源连接铝排"},
        {url:require("@/img/products/DSC_0071.jpg"),urls:[require("@/img/products/DSC_0071.jpg")],name:"新能源浸塑连接铜排"},
        {url:require("@/img/products/DSC_0072.jpg"),urls:[require("@/img/products/DSC_0072.jpg")],name:"低压连接片"},
        {url:require("@/img/products/DSC_0073.jpg"),urls:[require("@/img/products/DSC_0073.jpg")],name:"新能源连接铜排"},
        {url:require("@/img/products/DSC_0074.jpg"),urls:[require("@/img/products/DSC_0074.jpg")],name:"新能源连接铜排"},
        {url:require("@/img/products/DSC_0075.jpg"),urls:[require("@/img/products/DSC_0075.jpg")],name:"新能源连接铜排"},
        {url:require("@/img/products/DSC_0076.jpg"),urls:[require("@/img/products/DSC_0076.jpg")],name:"新能源连接铜排1926"},
        {url:require("@/img/products/DSC_0077.jpg"),urls:[require("@/img/products/DSC_0077.jpg")],name:"新能源连接铜排"},
        {url:require("@/img/products/DSC_0078.jpg"),urls:[require("@/img/products/DSC_0078.jpg")],name:"新能源浸塑连接铜排"},
        {url:require("@/img/products/DSC_0079.jpg"),urls:[require("@/img/products/DSC_0079.jpg")],name:"线路板连接端子1925"},
        {url:require("@/img/products/DSC_0080.jpg"),urls:[require("@/img/products/DSC_0080.jpg")],name:"新能源浸塑连接铜排"},
        {url:require("@/img/products/DSC_0081.jpg"),urls:[require("@/img/products/DSC_0081.jpg")],name:"新能源浸塑连接铜排"},
        {url:require("@/img/products/DSC_0082.jpg"),urls:[require("@/img/products/DSC_0082.jpg")],name:"新能源浸塑连接铜排"},
        {url:require("@/img/products/DSC_0083.jpg"),urls:[require("@/img/products/DSC_0083.jpg")],name:"新能源浸塑连接铜排"},
        {url:require("@/img/products/DSC_0084.jpg"),urls:[require("@/img/products/DSC_0084.jpg")],name:"新能源浸塑连接铜排"},
        {url:require("@/img/products/DSC_0085.jpg"),urls:[require("@/img/products/DSC_0085.jpg")],name:"动力电池铜铝复合极耳"},
        {url:require("@/img/products/DSC_0086.jpg"),urls:[require("@/img/products/DSC_0086.jpg")],name:"新能源连接铝排"},
        {url:require("@/img/products/DSC_0087.jpg"),urls:[require("@/img/products/DSC_0087.jpg")],name:"新能源连接铜排"},
        {url:require("@/img/products/DSC_0088.jpg"),urls:[require("@/img/products/DSC_0088.jpg")],name:"新能源连接铜排"},
        {url:require("@/img/products/DSC_0089.jpg"),urls:[require("@/img/products/DSC_0089.jpg")],name:"新能源连接铜排"},
        {url:require("@/img/products/DSC_0003.jpg"),urls:[require("@/img/products/DSC_0003.jpg")],name:"新能源V79动力电池盖"},
      ],
      [
        //其他主要产品
        {url:require("@/img/products/DSC_0040.jpg"),urls:[require("@/img/products/DSC_0040.jpg")],name:"除草机侧板"},
        {url:require("@/img/products/DSC_0017.jpg"),urls:[require("@/img/products/DSC_0017.jpg")],name:"程控机外壳"},
        {url:require("@/img/products/DSC_0018.jpg"),urls:[require("@/img/products/DSC_0018.jpg")],name:"半导体光源罩"},
        {url:require("@/img/products/DSC_0019.jpg"),urls:[require("@/img/products/DSC_0019.jpg")],name:"电池马达盖"},
        {url:require("@/img/products/DSC_0020.jpg"),urls:[require("@/img/products/DSC_0020.jpg")],name:"新能源动力电池盖"},
      ],
      ],
      picture:[],
      teses:[
        {name:"热隔层底盘组件",model:"HTIC-SILVER-001",englishName:"Thermal insulation chassis part",url:require("@/img/products/DSC_0065.jpg"),blurb:'这款0.15毫米厚的隔热罩是汽车底盘组件之一，具有阻隔热量传递的重要作用。其表面采用复杂花纹设计，不仅美观独特，还能有效增加表面积，提高散热效果。安装时需搭配陶瓷纤维隔热棉，提供更强隔热性能，降低底盘温度，保障车辆稳定性和可靠性。'},
        {name:"催化器进气端盖",model:"CVCC-IEC-052",englishName:"CV Catalytic Inlet Cap",url:require("@/img/products/DSC_0097.jpg"),blurb:'商用车催化器进气端盖采用精密设计，旨在有效减少排放物，提高引擎性能，符合严格的排放标准，从而提升燃油效率，延长发动机使用寿命。同时，这一端盖还具备优异的耐磨性和耐高温性能，确保在各种工况下均能稳定运行，为商用车辆的可靠性和持续性能提供了可靠保障。'},
        {name:"汽车消声包内组件",model:"AVPC-190",englishName:"Automotive Vehicle Package Component",url:require("@/img/products/DSC_0101.jpg"),blurb:'AVPC 的设计兼顾了耐久性和性能，不仅能够承受高温和振动，还能长期保持其消声特性。这种内组件常见于汽车的排气系统中，帮助减少发动机运转时的噪声，提升乘车舒适度，并符合越来越严格的噪音控制法规。'},
      ],
      tese_namber:1,
      picture_nambar:false,
      more:true,
      product_height:720,
      loading: true, // 控制骨架屏显示与隐藏
    }
  },
  mounted(){
    this.more_if();
  },
  methods:{
    //测试函数
    handleImageLoad() {
      this.loading = false; // 图片加载完成后隐藏骨架屏
    },
    //点击查看更多
    more_change(){
      //获取元素初始高度
      const height = this.$refs.products.clientHeight; 
      // 将元素的高度设置为自适应
      this.$refs.products.style.height = 'auto';
      this.more=false;
    },
    //是否显示查看更多这个选项
    more_if(){
      const height = this.$refs.products.clientHeight; 
      //判断初始是否大于最小高度
      // console.log("最低高度:"+this.product_height+"目前高度:"+height);
      if(height>this.product_height){
        this.more=true;
        this.$refs.products.style.height = this.product_height+'px';
      }else{
        this.more=false;
        this.$refs.products.style.height = 'auto';
      }
    },
    picture_click(img){
      if(img.class===0){
        this.picture=[img.url];
      }else{
        this.picture=img.urls;
      }
      this.picture_state_change();
    },
    picture_state_change(){
      if(!this.picture_nambar){
        this.picture_nambar=true;
        this.disableScroll();
      }else{
        this.picture_nambar=false;
        this.enableScroll();
      }
    },
    //判断改不改显示
    isActive(index){
      if(index===this.tese_namber-1){
        return true;
      }
      return false;
    },
    //更改应该显示的标号
    teseChange(index){
      this.tese_namber=index+1;
    },
    //修改在哪一个product_title
    products_titleChange(index){
      this.product_number=index;
      this.more_if();
    },
    //滚动条处理
    disableScroll() {
      this.$emit('ban_scroll', 'ban');
    },
    enableScroll() {
      this.$emit('ban_scroll', 'restore');
    }
  }
}
</script>

<style scoped lang="less">
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

/*第一个图片模块*/
.firstImg{
  height: 80vh;
  position: relative;
  min-width:1500px;
}
.firstImg img{
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.mengban{
  top:0;
  z-index: 1;
  background: linear-gradient(to bottom, rgba(120,120,120,0.3), rgba(255,255,255,0.1));
  position: absolute;
  width: 100%;
  height: 50%;
}
/* 特色产品模块 */
.tese{
  border-top: 2px solid #eee;
  padding: 100px 100px;
  margin: 0 auto;
  width: 1500px;
}
.tese_boxs{
  display: flex;
  flex-direction:column;
}
.tese_titleBox{
  position: relative;
}
.tese_title{
  font-weight: 550;
  font-size: 35px;
  color: #333;
  z-index: 2;
  position: relative;
}
.tese_title2{
  color: #2155b0;
}
.tese_enTitle{
  font-size: 50px;
  font-weight: 700;
  color: transparent;
  -webkit-text-stroke: 2px #eee; /* Safari 和部分浏览器支持 */
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
}
.tese_titleBox p{
  z-index: 2;
  position: relative;
  color: #aaa;
  line-height: 5em;
}
.tese_titleBox a{
  color: #fff;
  padding: 10px 20px;
  border-radius:20px;
  position: absolute;
  top: 0;
  right: 0;
  font-weight: 350;
  background: #2155b0;
}

.tese_bottom{
  display: flex;
}
.tese_indexs{
  transition:1s;
  margin: auto 0;
}
.tese_index{
  transition:0.25s;
  border-bottom: 2px solid #2155b0;
  margin: 40px 100px 40px 0;
  color: #333;
  position: relative;
  width: 300px;
  filter: grayscale(100%);
  opacity: 0.3;
  cursor: pointer;
  &:hover{
    filter: grayscale(0%);
    opacity: 1;
  }
  &.tese_active{
    filter: grayscale(0%);
    opacity: 1;
  }
}
.tese_index h1{
  font-size: 20px;
  font-weight: 550;
}
.tese_index p{
  color: #aaa;
  font-size: 14px;
  line-height: 2em;
  padding-bottom: 20px;
}
.tese_jiantou{
  position: absolute;
  right: 0;
  top: 0;
  border-radius:30px;
  width: 30px;
  height: 30px;
  color: #fff;
  /* 居中 */
  text-align: center;
  line-height: 30px;
  background: #2155b0;
}
.tese_img{
  width: 800px;
  height: 430px;
  position: relative;
}
.tese_img img{
  width: 100%;
  height: 100%;
  box-shadow: 0 0 5px rgba(0,0, 0, 0.5);
}
.tese_whiteBox{
  font-size: 14px;
  position: absolute;
  height: 80%;
  width: 250px;
  
  top: 40px;
  right: 40px;
  background: rgba(255,255, 255, 0.9);
  padding-top: 30px;
} 
.tese_whiteBox h1{
  font-size: 18px;
  padding: 0 20px;
  margin: 0 20px;
}
.tese_whiteBox p{
  border-top: 2px solid #eee;
  padding: 20px;
  margin: 0 20px;
  margin-top: 20px;
  font-size: 12px;
  color: #aaa;
  line-height: 1.7em;
}
/* 汽车主要产品模块 */
#products_boxs{
  width: 100%;
  min-width:1500px;
  background: linear-gradient(to top, rgba(135, 206, 250, 1), #2155b0);
  transition:1s;
  overflow:hidden;
}
.products_titles{
  position: relative;
  width: 1200px;
  margin: 0 auto 30px auto;
  color: #fff;
  display: flex;
  font-size: 20px;
  transition:1s;
  border-bottom: 2px solid rgba(200,200,200,0.3);
}
.products_title{
  position: relative;
  padding: 50px 0 20px 0;
  margin-right: 40px;
  filter: grayscale(100%);
  opacity: 0.5;
  cursor: pointer;
  transition: opacity 0.25s;
  &.products_act{
    border-bottom: 2px solid #fff;
    filter: grayscale(0%);
    opacity: 1;
    top: 2px; 
  }
}
.products_titles .iconfont{
  font-size: 28px;
  letter-spacing: 10px;
}
.products_imgs{
  // height: 720px;
  width: 1200px;
  padding: 0;
  margin: 0 auto;
  display: grid;
  grid-template-columns: auto auto auto auto;
  gap: 20px 20px;
  z-index: 1;
}

.products_more{
  text-align: center;
  box-shadow:0 -2px 2px rgba(0,0, 0, 0.2);
  // width: 1200px;
  margin: 0 auto;
  background: rgb(223, 242, 248);
  z-index: 2;
  position: relative;
  font-size: 17px;
  cursor: pointer;
}
.img_box{
 width: 285px;
//  height: 306.67px;
 object-fit: cover;
 font-size: 0;
}
.img_box img{
 width: 100%;
 height: 90%;
}
.img_box p{
  background: #eee;
  font-size: 14px;
  text-align: center;
  font-weight: 540;
  padding: 10px 0;
  color: #333;
}
// 图片模块
.picture_box{
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0,0, 0, 0.3);
  z-index: 5;
}
.main_box{
  position: absolute;
  width: 52.1vw;
  height: 70vh;
  top: 53%;
  left: 50%;
  background: #eee;
  transform: translate(-50%,-50%);
  box-shadow: 0 0 10px rgba(0,0, 0, 0.5);
  border-radius: 0 0 10px 10px;
}
.close{
  text-align: right;
  padding: 5px ;
  width: 100%;
  position: absolute;
  background: #eee;
  top:-30px;
  right: 0;
  border-radius: 10px 10px 0 0;
}
.close_main{
  cursor: pointer; 
  :hover{
    color: lightblue;
  }
}
.close_main .iconfont{
  font-size: 20px;
}
.pic_box{
  // display: grid;
  // grid-template-columns:auto auto;
  // padding: 20px;
  width: 100%;
  height: 100%;
  overflow: auto;
  border-radius: 0 0 10px 10px;
  img{
    // width: 100%;
    padding: 0 auto;
    margin: 0 auto;
    height: 70vh;
    width: auto; 
    object-fit: cover;
    display: block;
  }
}
</style>